import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  content: {
    flexGrow: 1,
    width: '100%',
    paddingTop: '70px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  withBottomBar: {
    paddingBottom: '90px'
  }
}))
